import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AmazonAdsService {
  private readonly url = '/api/amazon-ads';

  constructor(private http: HttpClient) {}

  getOAuthUrl(companyId: string) {
    return this.http.get<{ redirectUrl: string }>(this.url, {
      params: {
        companyId,
      },
    });
  }

  authenticate({ code, companyId }: { code: string; companyId: string }) {
    return this.http.post<{ companyId: string }>(`${this.url}/authenticate`, {
      code,
      companyId,
    });
  }

  syncCampaigns({ userId, companyId }: { userId: string; companyId: string }) {
    return this.http.post<void>(`${this.url}/sync`, { userId, companyId });
  }
}
